import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, CheckCircle2 } from "lucide-react";
import { Logomark } from "@/components/marketing/Navbar";
import { supabase } from "@/lib/supabase";

export default function Login() {
  const [authError, setAuthError] = useState(null);


  const handleLogin = async () => {
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: `${window.location.origin}/dashboard`
        }
      });
      if (error) throw error;
    } catch (e) {
      setAuthError(e);
    }
  };


  return (
    <div className="min-h-screen flex flex-col">
      <div className="px-6 py-5">
        <Link to="/" className="inline-flex items-center gap-2 text-sm ink-soft hover:ink" data-testid="back-to-home">
          <ArrowLeft className="h-4 w-4" /> back
        </Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-6 -mt-10">
        <div className="w-full max-w-sm">
          <div className="flex items-center gap-2.5 mb-10">
            <Logomark size={32} />
            <div className="font-display font-bold text-lg ink">TrustDmarc</div>
          </div>
          <h1 className="font-display text-4xl font-bold tracking-tight ink leading-[1.05]">
            Sign in to <span className="font-serif italic font-normal">TrustDmarc.</span>
          </h1>
          <p className="mt-3 ink-soft">Continue with Google to access your domain trust dashboard.</p>

          <button
            onClick={handleLogin}
            className="mt-8 w-full btn-secondary justify-center py-3 text-base font-medium"
            data-testid="google-signin-btn"
          >
            <svg className="h-5 w-5" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
            Sign in / Register
          </button>

          {authError && (
            <div className="mt-4 panel-soft p-5 text-sm bg-amber-100 border border-amber-300 rounded">
              Authentication is currently unavailable. Please try again later.
            </div>
          )}

          <div className="mt-8 flex items-center gap-2 text-xs ink-muted">
            <CheckCircle2 className="h-3.5 w-3.5 text-emerald-600" />
            <span>Single sign-on · No password to remember</span>
          </div>
        </div>
      </div>
    </div>
  );
}
